import { IFormTextFieldValidator } from '../../components/FormTextField';

const MinimumGuaranteeValidator: { [name: string]: IFormTextFieldValidator } = {
  PositiveNumberOnly: {
    hint: 'Please enter a valid value',
    rule: (value = '') => !isNaN(Number(value)) && Number(value) >= 0,
  },
};

export default MinimumGuaranteeValidator;
